import { render } from "./CustomerTypeAdd.vue?vue&type=template&id=38089e78"
import script from "./CustomerTypeAdd.vue?vue&type=script&lang=js"
export * from "./CustomerTypeAdd.vue?vue&type=script&lang=js"
script.render = render

export default script